var _rect, _rect2, _mask, _rect3, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCanvasEventEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 89.9999,
    height: 89.9999,
    rx: 15,
    transform: "matrix(0.707107 0.707106 -0.707107 0.707106 64 0)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 33.6396,
    width: 60,
    height: 59.9999,
    rx: 30,
    fill: "#FFE9F3"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_118_121364",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.625,
    y: 50.5146,
    width: 26.25,
    height: 18.75,
    rx: 1.875
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 54.625,
    y: 50.5146,
    width: 26.25,
    height: 18.75,
    rx: 1.875,
    stroke: "#FF2A87",
    strokeWidth: 6.75,
    strokeLinejoin: "round",
    mask: "url(#path-3-inside-1_118_121364)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.4375 52.3896L67.0145 59.106C67.6806 59.5731 68.5719 59.5574 69.2211 59.0671L78.0625 52.3896",
    stroke: "#FF2A87",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5 73.0146L45.25 76.7646",
    stroke: "#FF2A87",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.25 69.2646L50.875 67.3896",
    stroke: "#FF2A87",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.25 61.7646L50.875 59.8896",
    stroke: "#FF2A87",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanvasEventEmail);
export default __webpack_public_path__ + "static/media/canvas_event_email.9b44813dcef646cdd29407bd16797788.svg";
export { ForwardRef as ReactComponent };